import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import AddIcon from '@material-ui/icons/Add';
// import BackspaceIcon from '@material-ui/icons/Backspace';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },
}));

export default function Tag(props) {
    const classes = useStyles();

    return <li className={classes.root}>
        {props.isAttached ? 
            <Chip
                label={props.label}
                clickable
                color="primary"
                onDelete={props.handleDelete}
                // deleteIcon={<BackspaceIcon />}
                deleteIcon={<HighlightOffIcon />}
            /> : <Chip label={props.label} onClick={props.onClick} color="primary" deleteIcon={<AddIcon />} />}
            </li>
}